import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogConfig, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { LogoutReason } from '@portal-core/auth/enums/logout-reason.enum';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { IdleLogoutService } from '@portal-core/idle-logout/services/idle-logout.service';
import { AutoUnsubscribe } from '@portal-core/util/auto-unsubscribe.decorator';
import { Subscription, timer } from 'rxjs';

@Component({
    selector: 'mc-idle-logout-dialog',
    templateUrl: './idle-logout-dialog.component.html',
    styleUrls: ['./idle-logout-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatDialogTitle, MatIcon, CdkScrollable, MatDialogContent, MatDialogActions, MatButton]
})
@AutoUnsubscribe()
export class IdleLogoutDialogComponent implements OnInit {
  private readonly idleLogoutService = inject(IdleLogoutService);
  private readonly authService = inject(AuthService);
  public readonly dialogRef = inject<MatDialogRef<IdleLogoutDialogComponent, void>>(MatDialogRef);
  static DialogConfig: MatDialogConfig = {
    width: '36rem',
    disableClose: true // Don't allow click off - must choose a button to close.
  };

  initialTimeTillLogout: number;
  logoutTimerSubscription: Subscription;
  ngOnInit() {
    this.initialTimeTillLogout = this.idleLogoutService.warningOffsetMilliseconds;
    this.logoutTimerSubscription = timer(this.initialTimeTillLogout).subscribe(() => {
      this.authService.logout(LogoutReason.IdleTimeExpiration);
    });
  }

  onSignOutClicked() {
    this.authService.logout();
  }

  onExtendIdleTimerClicked() {
    this.idleLogoutService.extendIdleTimer();
    this.dialogRef.close();
  }
}
